<template>
  <div>
    <v-dialog v-model="open" scrollable persistent max-width="1200">
      <v-card>
        <div
          style="display: flex; justify-content: space-between; align-items: center"
          class="px-3 py-1"
        >
          <div>
            <h3>
              {{ formType === 'add' ? $t('bbl.add_job_interest') : $t('bbl.edit_job_interest') }}
            </h3>
          </div>
          <div class="text-xs-right">
            <v-btn small flat fab @click="handleCancel">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </div>
        <v-divider></v-divider>
        <v-card-text>
          <div>
            <div class="mb-2">
              <h3>{{ $t('bbl.job_position') }} (หัวข้อใหญ่)</h3>
            </div>

            <v-layout wrap>
              <v-flex
                xs12
                sm6
                class="form-control px-1"
                :class="{ 'has-error': errors.has('name_th') }"
              >
                <div class="caption mb-1">{{ $t('name_th') }} <span class="red--text">*</span></div>
                <input
                  v-model="input.name_th"
                  v-validate="{
                    required: true
                  }"
                  type="text"
                  :placeholder="$t('name_th')"
                  class="form-control"
                  maxlength="255"
                  :data-vv-as="$t('name_th')"
                  name="name_th"
                />
                <p v-if="errors.has('name_th')" class="text-error">{{ errors.first('name_th') }}</p>
              </v-flex>
              <v-flex
                xs12
                sm6
                class="form-control px-1"
                :class="{ 'has-error': errors.has('name_en') }"
              >
                <div class="caption mb-1">{{ $t('name_en') }} <span class="red--text">*</span></div>
                <input
                  v-model="input.name_en"
                  v-validate="{
                    required: true
                  }"
                  type="text"
                  :placeholder="$t('name_en')"
                  class="form-control"
                  maxlength="255"
                  :data-vv-as="$t('name_en')"
                  name="name_en"
                />
                <p v-if="errors.has('name_en')" class="text-error">{{ errors.first('name_en') }}</p>
              </v-flex>
            </v-layout>
            <v-divider class="mt-3"></v-divider>

            <v-layout wrap class="mt-2" align-center>
              <v-flex xs6>
                <h3>ตำแหน่งงาน (หัวข้อย่อย)</h3>
              </v-flex>
              <v-flex xs6 style="display: flex; justify-content: flex-end">
                <v-btn
                  style="justify-content: center; align-items: center"
                  color="primary"
                  depressed
                  @click="handleAddJobPosition"
                >
                  <em class="fas fa-plus mr-1"></em> {{ $t('bbl.add_job_position') }}
                </v-btn>
              </v-flex>
            </v-layout>
            <template v-if="bangkokbank_job_interests.length > 0">
              <v-list>
                <draggable
                  :list="bangkokbank_job_interests"
                  class="dragArea"
                  :move="checkSortItems"
                  item-key="id"
                  :animation="200"
                >
                  <div
                    v-for="(job, index) in bangkokbank_job_interests"
                    :key="job.id"
                    style="display: flex; width: 100%"
                  >
                    <v-layout row>
                      <v-flex shrink pa-1>
                        <em class="fas fa-grip-vertical" />
                      </v-flex>
                      <v-flex grow pa-1>
                        <div style="width: 100%">
                          <div
                            class="intent-item pa-2 mb-3"
                            style="
                              border-width: 1px;
                              border-style: solid;
                              border-color: rgb(255, 112, 107);
                              border-image: initial;
                              width: 100%;
                            "
                          >
                            <v-layout wrap>
                              <v-flex
                                xs12
                                sm6
                                class="form-control px-1"
                                :class="{ 'has-error': errors.has('job_name_th') }"
                              >
                                <div class="caption mb-1">
                                  {{ $t('name_th') }} <span class="red--text">*</span>
                                </div>
                                <input
                                  v-model="job.name_th"
                                  v-validate="{
                                    required: true
                                  }"
                                  type="text"
                                  :placeholder="$t('name_th')"
                                  class="form-control"
                                  maxlength="255"
                                  :data-vv-as="$t('name_th')"
                                  name="job_name_th"
                                />
                                <p v-if="errors.has('job_name_th')" class="text-error">
                                  {{ errors.first('job_name_th') }}
                                </p>
                              </v-flex>
                              <v-flex
                                xs12
                                sm6
                                class="form-control px-1"
                                :class="{ 'has-error': errors.has('job_name_en') }"
                              >
                                <div class="caption mb-1">
                                  {{ $t('name_en') }} <span class="red--text">*</span>
                                </div>
                                <input
                                  v-model="job.name_en"
                                  v-validate="{
                                    required: true
                                  }"
                                  type="text"
                                  :placeholder="$t('name_en')"
                                  class="form-control"
                                  maxlength="255"
                                  :data-vv-as="$t('name_en')"
                                  name="job_name_en"
                                />
                                <p v-if="errors.has('job_name_en')" class="text-error">
                                  {{ errors.first('job_name_en') }}
                                </p>
                              </v-flex>
                              <v-flex
                                xs12
                                sm6
                                class="form-control px-1 pb-2"
                                :class="{ 'has-error': errors.has('job_location') }"
                              >
                                <div class="caption mb-1">
                                  {{ $t('bbl.job_location') }}
                                </div>

                                <v-layout row wrap>
                                  <v-flex
                                    v-for="(location, locationIndex) in locationOptions"
                                    :key="`bbl-location-${locationIndex + 1}`"
                                  >
                                    <v-checkbox
                                      v-model="job.zone"
                                      :label="location.label"
                                      :value="location.value"
                                      hide-details
                                      class="mt-0"
                                      color="primary"
                                    ></v-checkbox>
                                  </v-flex>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                          </div>
                        </div>
                      </v-flex>
                      <v-flex shrink pa-1>
                        <v-btn
                          fab
                          outline
                          color="primary"
                          class="extra-small ma-1"
                          @click="handleRemoveJobPosition(index)"
                        >
                          <em class="fa fa-trash" />
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </div>
                </draggable>
              </v-list>
            </template>
            <template v-else>
              <div class="text-xs-center grey lighten-3 py-3 mt-1" style="border-radius: 10px">
                {{ $t('no_data') }}
              </div>
            </template>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="display: flex; justify-content: center; gap: 12px" class="py-3">
          <v-btn color="grey" outline @click="handleCancel">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="handleSave">{{ $t('Save') }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import bangkokbankApi from '@/api/bangkokbank.js'
import { handleApiError } from '@/api/util'
import draggable from 'vuedraggable'
import { mapGetters } from 'vuex'

export default {
  components: {
    draggable
  },
  props: {
    formType: {
      type: String,
      default: 'add' // add,edit
    },
    editData: {
      type: Object,
      default: () => {}
    },
    dialogOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      open: this.dialogOpen,
      input: {
        name_en: '',
        name_th: ''
      },
      bangkokbank_job_interests: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    locationOptions() {
      return [
        { label: 'กรุงเทพมหานคร', value: 'กรุงเทพมหานคร' },
        { label: 'ต่างจังหวัด', value: 'ต่างจังหวัด' }
      ]
    }
  },
  watch: {
    editData: {
      deep: true,
      handler() {
        this.handlePreFillForm()
      }
    }
  },
  mounted() {
    if (this.formType === 'edit') {
      this.handlePreFillForm()
    }
  },
  methods: {
    async handlePreFillForm() {
      if (this.editData) {
        const tempEditData = { ...this.editData }

        this.input.name_en = tempEditData.name_en
        this.input.name_th = tempEditData.name_th

        const tempBangkokbankJobInterests = tempEditData.bangkokbank_job_interests

        const mapDataJobInterest = tempBangkokbankJobInterests.map((item) => {
          return {
            name_th: item.name_th,
            name_en: item.name_en,
            zone: item.zone,
            sort: item.sort
          }
        })

        this.bangkokbank_job_interests = mapDataJobInterest
      }
    },
    async handleSave() {
      const vm = this
      try {
        const result = await vm.$validator.validateAll()
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        if (vm.bangkokbank_job_interests && vm.bangkokbank_job_interests.length === 0) {
          await vm.$swal({
            text: 'กรอกตำแหน่งงานอย่างน้อย 1 ตำแหน่ง',
            type: 'error'
          })

          return
        }

        const payload = {
          name_th: vm.input.name_th,
          name_en: vm.input.name_en,
          bangkokbank_job_interests: vm.bangkokbank_job_interests,
          page_id: vm.selectedBot.pageid
        }

        let response = null

        if (vm.formType === 'add') {
          response = await vm.onCreateBangkokbankJobInterests(payload)
        } else if (vm.formType === 'edit') {
          Object.assign(payload, {
            id: vm.editData.id
          })
          response = await vm.onUpdateBangkokbankJobInterests(payload)
        }

        if (response && response.status === 204) {
          await vm.$swal.fire({
            type: 'success',
            title: this.$t('Success')
          })
          vm.$emit('onSaveSuccess')
          vm.input = {
            name_en: '',
            name_th: ''
          }
          vm.bangkokbank_job_interests = []
        }
      } catch (error) {
        console.error(error)
      }
    },
    async onCreateBangkokbankJobInterests(payload) {
      const vm = this
      try {
        if (!payload) return

        const response = await bangkokbankApi.createBangkokbankJobInterests(payload)

        if (response) {
          return response
        }

        return null
      } catch (error) {
        if (error.response.status === 409) {
          await vm.$swal.fire({
            type: 'error',
            title: this.$t(`job_duplicate`)
          })
        } else {
          handleApiError(error)
        }
        return null
      }
    },
    async onUpdateBangkokbankJobInterests(payload) {
      try {
        if (!payload) return

        const response = await bangkokbankApi.putEditBangkokbankJobInterests(payload)

        if (response) {
          return response
        }

        return null
      } catch (error) {
        if (error.response.status === 409) {
          await this.$swal.fire({
            type: 'error',
            title: this.$t(`job_duplicate`)
          })
        } else {
          handleApiError(error)
        }
        return null
      }
    },
    handleCancel() {
      this.$emit('onCloseDialog')
    },
    handleAddJobPosition() {
      this.bangkokbank_job_interests.push({
        name_th: '',
        name_en: '',
        zone: [],
        sort: this.bangkokbank_job_interests.length + 1
      })
    },
    handleRemoveJobPosition(index) {
      this.bangkokbank_job_interests.splice(index, 1)
      this.bangkokbank_job_interests.forEach((job, index) => {
        job.sort = index
      })
    },
    checkSortItems() {
      this.bangkokbank_job_interests.forEach((job, index) => {
        job.sort = index
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/bblcareer/Job/JobManageFormDialog.vue